import axios from 'axios';
import { API_URL } from '../config';
import initialState from './initialState';
export const getZones = ({ zone }) => zone;

const reducerName = 'zone';
const createActionName = (name) => `app/${reducerName}/${name}`;

const LOAD_ZONES = createActionName('LOAD_ZONES');

export const loadZones = (payload) => ({ payload, type: LOAD_ZONES });

export const loadZonesRequest = () => {
  return async (dispatch) => {
    try {
      let res = await axios.get(`${API_URL}/zone`);
      dispatch(loadZones(res.data));
    } catch (e) {
      console.log(e.message);
    }
  };
};

const zonesReducer = (statePart = initialState, action = {}) => {
  switch (action.type) {
    case LOAD_ZONES:
      return [...action.payload];
    default:
      return statePart;
  }
};

export default zonesReducer;
